<template>
  <div id="app">
    <!-- <div v-if="headerShow">
      <top-bar></top-bar>
    </div> -->
    <router-view />
    <!-- <el-backtop :bottom="100" :visibility-height="50"></el-backtop> -->
    <!-- loading加载 -->
    <Loading></Loading>
    <!-- <div style="height: 30px;"></div> -->
  </div>
</template>
<script>
import TopBar from "./components/TopBar";
import Loading from "./components/Loading/loading.vue"
export default {
  data() {
    return {
      // headerShow: true,
    };
  },
  computed: {},
  components: {
    // "top-bar": TopBar,
    Loading,
  },
  mounted(){
    // if (this.$route.path === "/home") {
    //     this.headerShow = true;
    //   } else {
    //     this.headerShow = false;
    //   }
  },
  watch: {
    // 监听事件
    // $route() {
    //   if (this.$route.path === "/home") {
    //     this.headerShow = true;
    //   } else {
    //     this.headerShow = false;
    //   }
    // },
  },
};
</script>
<style>
@import "./assets/css/font.css";
@import "./assets/css/react.css";
</style>


